import { render, staticRenderFns } from "./GeneralTerms.vue?vue&type=template&id=24475bc8"
import script from "./GeneralTerms.vue?vue&type=script&lang=js"
export * from "./GeneralTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports